// A tiny global loading manager for tracking in-flight operations (e.g., API calls)
// and notifying listeners. Keeps UI concerns decoupled from the data layer.

export interface GlobalLoadingState {
  count: number;
}

type LoadingListener = (state: GlobalLoadingState) => void;

let inFlightCount = 0;
const listeners = new Set<LoadingListener>();

function notifyListeners(): void {
  const snapshot: GlobalLoadingState = { count: inFlightCount };
  listeners.forEach((listener) => {
    try {
      listener(snapshot);
    } catch (_err) {
      // Swallow listener errors to avoid impacting others
    }
  });
}

export function onGlobalLoadingChange(listener: LoadingListener): () => void {
  listeners.add(listener);
  // Immediately inform the new listener of current state
  listener({ count: inFlightCount });
  return () => listeners.delete(listener);
}

export function beginGlobalLoading(): () => void {
  inFlightCount += 1;
  notifyListeners();
  let finished = false;
  return () => {
    if (finished) return;
    finished = true;
    inFlightCount = Math.max(0, inFlightCount - 1);
    notifyListeners();
  };
}

export function getGlobalLoadingCount(): number {
  return inFlightCount;
}

